import { render, staticRenderFns } from "./PassSafeGuardCert.vue?vue&type=template&id=62ac30c2&"
import script from "./PassSafeGuardCert.vue?vue&type=script&lang=js&"
export * from "./PassSafeGuardCert.vue?vue&type=script&lang=js&"
import style0 from "./PassSafeGuardCert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports